<div style="padding: 15px" >
  <h2 *ngIf="!isPassExpired">Reset Password</h2>
  <h2 *ngIf="isPassExpired">Password Expired</h2>
  <p>Please enter a new password for your account.</p>
  <form [formGroup]="passwordForm" (ngSubmit)="onSubmit()">
    <!-- Old Password-->
    <mat-form-field style="width: 100%" *ngIf="isPassExpired">
      <mat-label>Old Password</mat-label>
      <input matInput [type]="hideOldPassword ? 'password' : 'text'" formControlName="oldPassword" />
      <button mat-icon-button matSuffix type="button" (click)="hideOldPassword = !hideOldPassword">
      <mat-icon>{{ hideOldPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
      </button>
      <mat-error *ngIf="isPassExpired && passwordForm.get('oldPassword')?.hasError('required')">
      Password is required
      </mat-error>
    </mat-form-field>
          <!-- New Password -->
    <mat-form-field style="width: 100%">
      <mat-label>New Password</mat-label>
      <input matInput [type]="hidePassword ? 'password' : 'text'" formControlName="newPassword" />
      <button mat-icon-button matSuffix type="button" (click)="hidePassword = !hidePassword">
        <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
      </button>
      <mat-error *ngIf="passwordForm.get('newPassword')?.hasError('required')">
        Password is required
      </mat-error>
      <mat-error *ngIf="passwordForm.get('newPassword')?.hasError('minlength') && !passwordForm.get('newPassword')?.hasError('required')">
        Password must be at least 12 characters
      </mat-error>
      <mat-error *ngIf="passwordForm.get('newPassword')?.hasError('pattern') && !passwordForm.get('newPassword')?.hasError('required')">
        Must include uppercase, lowercase, number, and special character
      </mat-error>
    </mat-form-field>

    <!-- Confirm Password -->
    <mat-form-field style="width: 100%">
      <mat-label>Confirm Password</mat-label>
      <input matInput [type]="hideConfirm ? 'password' : 'text'" formControlName="confirmPassword" />
      <button mat-icon-button matSuffix type="button" (click)="hideConfirm = !hideConfirm">
        <mat-icon>{{ hideConfirm ? 'visibility_off' : 'visibility' }}</mat-icon>
      </button>
      <mat-error *ngIf="passwordForm.get('confirmPassword')?.hasError('required')">
        Confirm password is required
      </mat-error>
      <mat-error *ngIf="passwordForm.hasError('mismatch') && passwordForm.get('confirmPassword')?.touched && !passwordForm.get('confirmPassword')?.hasError('required')">
        Passwords do not match
      </mat-error>
    </mat-form-field>
        <button mat-raised-button color="primary" type="submit" [disabled]="passwordForm.invalid">Submit</button>
  </form>
      <span *ngIf="isWrong" style="color: red;">
        Old password doesn't match
      </span>
</div>

